"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SapphirePoolStorageFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SapphirePoolStorageFactory = /** @class */ (function (_super) {
    __extends(SapphirePoolStorageFactory, _super);
    function SapphirePoolStorageFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SapphirePoolStorageFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SapphirePoolStorageFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SapphirePoolStorageFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SapphirePoolStorageFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SapphirePoolStorageFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SapphirePoolStorageFactory;
}(contracts_1.ContractFactory));
exports.SapphirePoolStorageFactory = SapphirePoolStorageFactory;
var _abi = [
    {
        inputs: [],
        name: "stablesLent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x6080604052348015600f57600080fd5b50607d8061001e6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063d0042e1314602d575b600080fd5b603560005481565b60405190815260200160405180910390f3fea26469706673582212209e14115c2ebd6e425f9ef2a4a48098adc8bf0bd4ef364b2ce8142a6ff63d222964736f6c63430008040033";
